import React, { useState } from "react";
import * as styles from "./ArticleListing.module.css";
import { Image, ComponentProps, ComponentWidth } from "../../../types/index";
import { Link } from "../../elements/Link/Link";
import { KontentImageElement } from "../../elements/KontentImageElement/KontentImageElement";
import { SectionWrapper } from "../../containers/SectionWrapper";

interface Props extends ComponentProps, ComponentWidth {
  categories: {
    name: string;
    articles: {
      title: string;
      url: string;
      image?: Image;
    }[];
  }[];
}

export const ArticleListing: React.FC<Props> = ({
  categories,
  width,
  ...props
}) => {
  const [visibleItemsPerCategory, setVisibleItemsPerCategory] = useState<
    Record<number, number>
  >(() => {
    // Initialize with 5 visible items for each category
    const initial: Record<number, number> = {};
    categories.forEach((_, index) => {
      initial[index] = 5;
    });
    return initial;
  });

  let classes = [styles.container];

  if (width === "contained") {
    classes.push(styles.contained);
  }

  const handleViewMore = (categoryIndex: number) => {
    setVisibleItemsPerCategory((prev) => ({
      ...prev,
      [categoryIndex]: Math.min(
        prev[categoryIndex] + 5,
        categories[categoryIndex].articles.length
      ),
    }));
  };

  return (
    <SectionWrapper {...props}>
      <div className={styles.wrapper}>
        <div className={classes.join(" ")}>
          {categories.map((category, categoryIdx) => {
            const visibleItems = visibleItemsPerCategory[categoryIdx];
            const hasMoreItems = visibleItems < category.articles.length;

            console.log(hasMoreItems);

            return (
              <div key={categoryIdx}>
                <h3>{category.name}</h3>
                <ul>
                  {category.articles
                    .slice(0, visibleItems)
                    .map((article, articleIdx) => {
                      return (
                        <li key={articleIdx}>
                          <Link to={article.url}>
                            {articleIdx === 0 && article.image?.item ? (
                              <KontentImageElement
                                layout="constrained"
                                aspectRatio={425 / 300}
                                width={425}
                                image={article?.image?.item}
                                alt={article?.image?.alt}
                              />
                            ) : null}
                            <p className={styles.title}>{article.title}</p>
                          </Link>
                        </li>
                      );
                    })}
                </ul>

                {hasMoreItems && (
                  <div className={styles.viewMoreContainer}>
                    <button
                      className={styles.viewMoreButton}
                      onClick={() => handleViewMore(categoryIdx)}
                    >
                      <strong>View More...</strong>
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </SectionWrapper>
  );
};
